module.exports = __webpack_public_path__ + "img/resep@2x.4f738e5e.png";